export enum StepModalTextType {
  MINT = 'mint',
  TRANCHE = 'tranche',
  CLAIM = 'claim',
  CANCEL = 'cancel',
  SWAP = 'swap',
}

export enum TransactionCompletedModalTextType {
  MINT = 'mint',
  SENIOR = 'senior',
  JUNIOR = 'junior',
  CLAIM = 'claim',
  CANCEL = 'cancel',
  SWAP = 'swap',
}
